
export default {
  "m":{
    "sms_login":"लघु संदेश लॉगिन",
    "get_vercode":"भेजना",
    "change_mobile":"फ़ोन नंबर बदलें",
    "log_reg_agree":"लॉगिन/पंजीकरण का अर्थ है {msg_ss} . से सहमत होना",
    "old_mobile":"मूल फोन नंबर",
    "new_mobile":"नया फोन नंबर",
    "agency_reginfo_fill":"गिल्ड पंजीकरण जानकारी भरें",
    "audit_res":"लेखापरीक्षा परिणाम",
    "agency_name":"गिल्ड का नाम",
    "agency_name_input":"कृपया एक गिल्ड नाम दर्ज करें",
    "agency_name_input_note":"नोट: गिल्ड नाम छोटा और याद रखने में आसान होने की सिफारिश की जाती है, 30 शब्दों से अधिक नहीं",
    "agency_logo":"गिल्ड LOGO",
    "agency_logo_unpload_note":"कृपया PNG/JPG/JPEG प्रारूप में एक स्पष्ट गिल्ड LOGO अपलोड करें",
    "agency_contact_name":"गिल्ड संपर्क व्यक्ति",
    "user_contact_name":"कृपया उस व्यक्ति का नाम भरें जो उपयोगकर्ता प्लेटफॉर्म के साथ दैनिक संपर्क में है",
    "agency_contact_phone":"गिल्ड संपर्क फोन नंबर",
    "agency_whatsapp":"गिल्ड लीडर WhatsApp",
    "agency_whatsapp_contact":"कृपया गिल्ड लीडर की WhatsApp संपर्क जानकारी दर्ज करें",
    "agency_use_lang":"गिल्ड लीडर द्वारा इस्तेमाल की जाने वाली भाषा",
    "agency_head_ID":"गिल्ड लीडर ID",
    "agency_ID_input":"कृपया बाद में फंड वितरण के लिए गिल्ड लीडर BuzzCast APP की यूजर ID दर्ज करें",
    "reg_country":"पंजीकरण का देश",
    "inhand_ID_photo":"हाथ पर फोटो आईडी",
    "upload_note_t":"अपलोड नोट्स",
    "agency_self_inhand_ID":"इसे एजेंट द्वारा स्वयं पासपोर्ट दस्तावेज़ के साथ ले जाना चाहिए",
    "photo_must_clearly":"सामने वाले हिस्से को फोटो खींचकर स्पष्ट रूप से व्यक्ति और वास्तविक पासपोर्ट की जानकारी दिखानी चाहिए",
    "mian_form_country":"मेजबान की उत्पत्ति का मुख्य देश",
    "invite_code":"निमंत्रण कोड",
    "your_profile_submit_success":"आपका दस्तावेज़ सफलतापूर्वक सबमिट कर दिया गया है! हम इससे जल्द से जल्द निपटेंगे<br>ऑडिट के परिणाम गिल्ड लीडर के बज़कास्ट BuzzCast APP को भेजे जाएंगे, और कृपया जांच पर ध्यान दें!",
    "your_profile_approved":"आपके द्वारा सबमिट किया गया दस्तावेज़ समीक्षा में पास नहीं हुआ है! अस्वीकृति का कारण है होल्डिंग पासपोर्ट की तस्वीर स्पष्ट नहीं है\"।<br>कृपया परामर्श के लिए BuzzCastApp पर आधिकारिक सहायक को फिर से भरें या संपर्क करें।",
    "return_refill":"वापस जाओ और फिर से भरना",
    "success_agency":"मंच की सफल स्थापना के लिए बधाई, काम शुरू करने के लिए [मुझे क्लिक करें]!",
    "personal_account":"व्यक्तिगत खाता",
    "my_agency":"मेरी एजेंसी",
    "your_agency_been_forcibly":"आपके गिल्ड को प्लेटफ़ॉर्म द्वारा जबरन समाप्त कर दिया गया है, और अब आप सिस्टम में लॉग इन नहीं कर पाएंगे।<br>यदि आपके कोई प्रश्न हैं, तो कृपया BuzzCastAPP के आधिकारिक सहायक या विशेष ऑपरेशन से संपर्क करें।",
    "invite_live_join":"गिल्ड लिंक में शामिल होने के लिए मेजबान को आमंत्रित करें",
    "base_info":"मूल जानकारी",
    "apply_time":"आवेदन तिथि",
    "join_time":"शामिल होने का समय",
    "cooper_status":"सहयोग की स्थिति",
    "streamer_manage":"मेजबान प्रबंधन",
    "sereamer_apply":"मेज़बान की मंज़ूरी",
    "sereamer_nickname":"होस्ट उपनाम",
    "remark":"टिप्पणी",
    "no_remark":"कोई टिप्पणी नहीं",
    "add_remark":"टिप्पणी जोड़ें",
    "birth":"जन्म की तारीख",
    "user_status":"उपयोगकर्ता की स्थिति",
    "temporarily_frozen":"अस्थायी फ्रीज",
    "permanently_frozen":"हमेशा के लिए फ्रीज करें",
    "fans_num":"अनुयायियों की संख्या",
    "sign_status":"अनुबंध स्थिति",
    "sign_ing":"अनुबंध के तहत",
    "sign_time":"अनुबंध की तारीख",
    "release_time":"रद्द करने की तारीख",
    "live_viola_record":"लाइव प्रसारण उल्लंघन रिकॉर्ड",
    "sign_record":"अनुबंध रिकॉर्ड",
    "current_contract_status":"वर्तमान अनुबंध की स्थिति",
    "termination_reason":"समाप्ति का कारण",
    "violation_reason":"उल्लंघन का कारण",
    "violation_time":"उल्लंघन की तारीख",
    "processing_result":"प्रक्रिया परिणाम",
    "exported_data":"निर्यात जानकारी",
    "join_agency_apply":"गिल्ड में शामिल होने की स्वीकृति",
    "audit_status":"अनुमोदन स्थिति",
    "pending_review":"लंबित समीक्षा",
    "pending_HQ_review":"मुख्यालय समीक्षा की प्रतीक्षा में",
    "not_approved_HQ":"मुख्यालय की समीक्षा विफल",
    "withdrawn":"निरस्त किया गया",
    "audit_trail":"समीक्षा रिकॉर्ड",
    "oper":"संचालन",
    "other_video_materials":"अन्य वीडियो दस्तावेज़",
    "pass":"उत्तीर्ण",
    "pass_streamer_join_agency_apply":"गिल्ड में शामिल होने के लिए मेजबान के लिए आवेदन पास करें",
    "reject_streamer_join_agency_apply":"गिल्ड में शामिल होने के लिए मेजबान के आवेदन को अस्वीकार करें",
    "agree_streamer_join_agency":"{msg_ss2} से नीचे प्रेषक बनने के लिए एंकर {msg_ss1} से सहमत हैं~",
    "reject_streamer_join_agency":"सदस्य {msg_ss1} का {msg_ss2} का सदस्य बनने का आवेदन अस्वीकृत!",
    "img_material":"चित्र दस्तावेज़",
    "approver":"स्वीकृति प्रदान करने वाले",
    'user_enter_bind_phone':'कृपया अपना मोबाइल फ़ोन नंबर दर्ज करें',
    'vericode':'सत्यापन कोड',
    'input_vericode':'सत्यापन कोड दर्ज करें',
    'login':'लॉग इन करें',
    'reg':'दर्ज कराई',
    'logout':'छोड़ना',
    'search_for':'एक खोज खोजें',
    'subscription_closed':'रद्द अनुबंध',
    'agency_ID':'गिल्ड कोड: {msg_ss}',
    'reset':'साथ रीसेट करें',
    'live_ID':'लाइव प्रसारण कक्ष आईडी',
    'live_record':'लाइव प्रसारण स्क्रीन रिकॉर्डिंग',
    'email':'ईमेल पता',
    'phone':'फ़ोन',
    'mastery_lang':'मास्टर भाषा',
    'to':'तक',
    'cancel':'रद्द करना',
    'Confirm':'निर्धारित',
    'preview':'पूर्वावलोकन',
    'rejected':'अस्वीकृत',
    'tip':'शीघ्र',
    'i_got_it':'मैंने इसे',
    'cancelled':'रद्द',
    'refused':'इनकार',
    'agency_agree':'गिल्ड सहमत हो गया है',
    'platform_agree':'मंच सहमत',
    'user_not_exist':'गैर-मौजूद उपयोगकर्ता',
    'user_frozen':'उपयोगकर्ता को फ्रीज कर दिया गया है',
    'reviewing':'समीक्षा में',
    'review_pass':'समीक्षा पारित',
    'review_failed':'ऑडिट फेल',
    'xx_hours':'{msg_ss} घंटे',
    'xx_days':'{msg_ss} दिन',
    'xx_hour': '{msg_ss} घंटा',
    'xx_day': '{msg_ss} दिन',
    'xx_year': '{msg_ss} वर्ष',
    'xx_years': '{msg_ss} वर्ष',
    'check_phone_istrue':'कृपया फ़ोन नंबर जांचें कि क्या सही ढंग से दर्ज किया गया है',
    'male':'नर',
    'female':'महिला',
    'avatar':'चित्र',
    'normal':'साधारण',
    'live_room':'कमरा जिएं',
    'view':'राय',
    'oper_success':'सफल ऑपरेशन',
    'copy_success':'सफल प्रति',
    'new_mobile_already_reg':'नया मोबाइल नंबर पंजीकृत है',
    'general_user':'सामान्य उपयोगकर्ता',

    'copy':'प्रतिलिपि',
    'gender':'लिंग',
    'submit':'प्रस्तुत करना',
    'permanent':'स्थायी',
    'agree_agreement':'अनुबंध से सहमत और पालन करें',
    'vericode_error':'सत्यापन कोड गलत है',
    'resend':'पुन: भेजें',
    'approved':'उत्तीर्ण',
    'not_approved':'पास करने में विफल',
    'agency_rejected':'प्लेटफार्म खारिज',
    'select':'चुनते हैं',
    'search':'खोज',
    'rejection_reason':'खारिज करने का कारण',
    'no_data':'कोई आकड़ा उपलब्ध नहीं है',
    'oper_failed':'कार्रवाई विफल',
    'leave_agency_apply':'गिल्ड वापस लेने की मंजूरी',
    'over_word_limit':'शब्द सीमा पार हो गई',
    'delete':'हटाना',
    'nickname':'उपनाम',
    'file_is_too_large':'बहुत बड़ी फाइल',

    'community_convention':'Buzzcast सामुदायिक कन्वेंशन',
    'approval_time':'अनुमोदन का समय',
    'guild_system_title':'बज़कास्ट सोशल प्लेटफ़ॉर्म गिल्ड सिस्टम',
    'return':'लौटना',
    'img_upload_fail':'छवि अपलोड विफल रही',
    'cooper_ing':'सहयोग जारी',
    'upload_file_format_incorrect':'अपलोड की गई फ़ाइल सही प्रारूप में नहीं है',
    'token_invalid':'टोकन अमान्य है, कृपया फिर से लॉग इन करें!',
    'network_busy':'नेटवर्क व्यस्त है, कृपया पुनः प्रयास करें',
    'minute':'{msg_ss}मिनट',

    'live_room_ID':'लाइव रूम आईडी',
    'scan_code':'बज़कास्ट एपीपी लॉग इन करने के लिए कोड स्कैन करता है',
    'open_code':'बज़कास्टऐप खोलें और स्कैन करने के लिए मेरा क्यूआर कोड पर क्लिक करें',
    'refresh':'प्लावित',
    'login_confirm':'लॉगिन ठीक है',
    'account':'खाते की जानकारी',
    'user_name':'उपयोगकर्ता नाम',
    'edit':'संशोधित करना',
    'changing':'बाइंडिंग स्वैप करें',
    'mobile_number':'मोबाइल फ़ोन खाता',
    'mobile_login':'आप मोबाइल नंबर {msg_ss} का उपयोग करके लॉग इन कर सकते हैं',
    'appId_login':'लॉग इन करने के लिए स्कैन करने के लिए आप [{msg_ss}] के ऐपआईडी के साथ खाते का उपयोग कर सकते हैं',
    'code_login':'बज़कास्टऐप आईडी बाउंड नहीं है, और आप बाइंडिंग के बाद लॉग इन करने के लिए कोड को स्कैन करने के लिए क्यूआर कोड का उपयोग कर सकते हैं',
    'verification_log':'मोबाइल फ़ोन नंबर बाउंड नहीं है, और आप बाइंडिंग के बाद लॉग इन करने के लिए मोबाइल फ़ोन नंबर और सत्यापन कोड का उपयोग कर सकते हैं',
    'binding_success':'बाइंडिंग सफल रही',
    'binding_mobile':'फ़ोन नंबर बाइंड करें',
    'edit_name':'उपयोगकर्ता नाम संशोधित करें',
    'binding_alert':'पुन: बाध्यकारी के लिए युक्तियाँ',
    'new_appId':'कोड बाइंडिंग को स्कैन करने के लिए सीधे नए एपीपीआईडी का उपयोग करें, मूल एपीपीआईडी को सीधे बदल दिया जाएगा',
    'binding_account':'बज़कास्टऐप खाते को बाइंड करें',
    'anchor_earings':'एंकर राजस्व',
    'signing_date':'हस्ताक्षर करने की तारीख',
    'statistical_date':'आँकड़ों की तारीख',
    'valid_min':'कुल मान्य अवधि (मिनट)',
    'valid_day':'मान्य दिन (दिन)',
    'total_revenue':'कुल रिटर्न',

    'bind':'बाइंडिंग',
    'please_agree_agree':'कृपया अनुबंध के लिए सहमत हों',
    'note':'नोट: इस प्रणाली द्वारा प्रदर्शित समय न्यूयॉर्क समय (EST) है',
    'app_phone':'APP का मोबाइल फोन नंबर पंजीकृत करें',
    'host_num':'मेजबान की संख्या',
    'enter_host_num':'कृपया सभी होस्ट की इसकी संख्या दर्ज करें',
    'platform':'सहयोग मंच',
    'statement':'मासिक बैंक विवरण',
    'enter_income':'कृपया औसत मासिक आय दर्ज करें',
    'check_commas':'गलत प्रारूप। कृपया जांचें कि क्या कई प्लेटफॉर्म अल्पविराम से अलग किए गए हैं',
    'submit_success':'आपका दस्तावेज़ सफलतापूर्वक सबमिट कर दिया गया है! हम इससे जल्द से जल्द निपटेंगे',
    'usd':'USD',
    'many_platforms':'कृपया उस लाइव ब्रॉडकास्ट प्लेटफॉर्म में प्रवेश करें जिसके साथ आपने पहले सहयोग किया है, 20 प्लेटफॉर्म तक',
    'limit_platform': '20 प्लेटफॉर्म तक',
    'user_has_delete':'उपयोगकर्ता को रद्द कर दिया गया है',
    'cant_commit':'आप पहले से ही एक अनुबंधित ब्रॉडकास्टर हैं, और आप एक ही समय में एक गिल्ड के लिए आवेदन नहीं कर सकते',
    'cant_commit_1':'आपने पहले ही एक अनुबंधित ब्रॉडकास्टर के लिए आवेदन कर दिया है, और आप एक ही समय में एक गिल्ड के लिए आवेदन नहीं कर सकते',
    'passwd': 'पासवर्ड',
    'passwd_placeholder': 'पासवर्ड समर्थन 6 से 20',
    'live_rights': 'समय-मुक्त मूल्यांकन',
    'edit_log': 'रिकॉर्ड बदलें',
    'edit_time': 'समय बदलें',
    'edit_pwd': 'पासवर्ड बदलें',
    'old_pwd': 'पुराना पासवर्ड',
    'new_pwd': 'नया पासवर्ड',
    'confirm_pwd': 'पासवर्ड की पुष्टि कीजिये',
    'forget_pwd': 'अपना पासवर्ड भूल गए?',
    'email_check': 'मेलबॉक्स स्वरूप गलत है',
    'phone_pwd_error': 'फोन नंबर या पासवर्ड गलत है',
    'ten_min_error': 'कृपया 10 मिनट में पुन: प्रयास करें',
    'phone_bind_error': 'मोबाइल फोन नंबर अन्य खातों के लिए बाध्य किया गया है, कृपया बाँधने के लिए नए मोबाइल फ़ोन नंबर को बदलें।',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'गिल्ड लीडर ID पहले ही भर दी गई है, कृपया फिर से भरें',
    'pwd_error': 'गलत पासवर्ड',
    'phone_not_reg_error': 'खाता पंजीकृत नहीं है',
    'pwd_nq': 'दो बार दर्ज किया गया नया पासवर्ड असंगत है',
    'sign_anchor_error': 'आप पहले से ही एक अनुबंधित ब्रॉडकास्टर हैं, और आप एक ही समय में एक गिल्ड के लिए आवेदन नहीं कर सकते',
    'apply_anchor_error': 'आपने पहले ही एक अनुबंधित ब्रॉडकास्टर के लिए आवेदन कर दिया है, और आप एक ही समय में एक गिल्ड के लिए आवेदन नहीं कर सकते',
    'have-expired':'खत्म हो चुका',
    'approval-time':'प्रोसेसिंग समय',
    'reasons-for-refusal':'कृपया अस्वीकृति का कारण दर्ज करें',
    'Transfer-grounds':'स्थानांतरण कारण',
    'code_expire': 'सत्यापन कोड समाप्त हो गया है, कृपया ताज़ा करने के लिए सत्यापन कोड पर क्लिक करें',
    'transfer-approval':'स्थानांतरण अनुमोदन',
    'live_state_placeholder': 'प्रसारण की स्थिति',
    'live_state_open': 'सामान्य',
    'live_state_temporary_banned': 'प्रतिबंधित',
    'live_state_forever_banned': 'स्थायी रूप से प्रतिबंधित',
    'live_allowed_time': 'स्ट्रीमिंग शुरू करने का समय',
    'live_banned_time': 'प्रतिबंध अवधि',
    'deduct_money': 'बी सिक्कों की मात्रा में कटौती करें',
    'final_income': 'वास्तविक आय',
    'select_start_dt': 'कृपया प्रारंभ समय चुनें',
    'select_end_dt': 'कृपया अंतिम समय चुनें',
    'less_then_end_dt': 'प्रारंभ समय से कम या अंत समय के बराबर होना चाहिए',
    'System_automatically_through':'सिस्टम स्वचालित रूप से गुजरता है',
    'btrade_err': 'एजेंसी आईडी उपलब्ध नहीं है',

    'mouth_anchor': 'मासिक वेतन का स्ट्रीमर',
    'day_anchor': 'दैनिक वेतन का स्ट्रीमर',
    'guild_anchor': 'समूह लीडर पुरस्कार (दैनिक वेतन)',
    'mouth_anchor_st': 'मासिक वेतन की शुरुआत का समय',
    'mouth_anchor_et': 'मासिक वेतन की समाप्ति का समय',
    'day_anchor_st': 'दैनिक वेतन की शुरुआत का समय',
    'day_anchor_et': 'दैनिक वेतन की समाप्ति का समय',
    'all_award_bcoin': 'दैनिक वेतन पुरस्कार की कुल कमाई',
    'live_hour': 'वैध लाइव समय का पुरस्कार',
    'salary_day': 'तारीख',
    'day_in_come': 'समूह की दैनिक कमाई(B कॉइन)',
    'award_ration_flag_str': 'पुरस्कार अनुपात',
    'payable_money': 'समूह लीडर के B कॉइन का पुरस्कार',
    'host_bcoins': 'स्ट्रीमर की आय B कॉइन्स',
    'total_official': 'आधिकारिक पुरस्कार B कॉइन्स की कुल संख्या',
    'actual_bcoins_awarded': 'वास्तविक पुरस्कार B कॉइन्स',
    "change_bound_account":"बाउंड खाता बदलें" ,
    "agent_id_form":"समूह नेता ID:" ,
    "BuzzCast_verification_code":"BuzzCast सत्यापन कोड:" ,
    "send_success":"सफलतापूर्वक भेजा गया" ,
    "account_changed_successfully":"बाउंड खाता सफलतापूर्वक बदला गया।" ,
    "invite_guild_url":"BuzzCast समूह नेता बनने के लिए आमंत्रण लिंक: {msg_ss}" ,
    "invite_guild_code":"मेरा आमंत्रण कोड: {msg_ss}" ,
    "save":"सहेजें" ,
    "compile":"संपादित" ,
    "agent_nvitation_eward":"समूह नेता आमंत्रण पुरस्कार" ,
    "agent_name":"समूह लीडर उपनाम" ,
    "guild_id":"समूह कोड" ,
    "guild_income_30days":"पिछले 30 दिनों की समूह आय" ,
    "guild_invite_income_30days":"पिछले 30 दिनों की आमंत्रण समूह आय" ,
    "agency_commission_ratio":"एजेंसी कमीशन अनुपात" ,
    "invite_income_bcoins":"निमंत्रण बी सिक्कों को पुरस्कृत करता है" ,
    "id_not_exist": "यह ID मौजूद नहीं है",
    'reward_distribution_status': 'पुरस्कार वितरण की स्थिति',
    'must_number': 'आपका इनपुट पूर्णतः संख्यात्मक प्रारूप में होना चाहिए।',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/hi.js